// import { initializeApp } from "firebase/app";
// import { getMessaging } from "firebase/messaging";

// const firebaseConfig = {
//  apiKey: "AIzaSyB-LD2sTMvZ-EL1EGnwavo21CHS7-_CKo0",
//   authDomain: "switchin-fe818.firebaseapp.com",
//   projectId: "switchin-fe818",
//   storageBucket: "switchin-fe818.firebasestorage.app",
//   messagingSenderId: "605576732540",
//   appId: "1:605576732540:web:5f8f8cdd85cc97e5430ef9",
//   measurementId: "G-GDBW6VMWY3"
// };

// const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAy2uIclj0Z3HZsVHjjLnmIUs3xLr-RvNI",
  authDomain: "switchin-b4153.firebaseapp.com",
  projectId: "switchin-b4153",
  storageBucket: "switchin-b4153.firebasestorage.app",
  messagingSenderId: "631447729782",
  appId: "1:631447729782:web:923f71186e55f8daf29157",
  measurementId: "G-8GKTH35JJN"
};

const app = initializeApp(firebaseConfig);

let messagingInstance = null;

export const getMessagingInstance = async () => {
  try {
    const supported = await isSupported();
    if (!supported) return null;

    if (!messagingInstance) {
      messagingInstance = getMessaging(app);
    }

    return messagingInstance;
  } catch (error) {
    console.error("Firebase messaging not supported:", error);
    return null;
  }
};

export default app;